import React, { useState } from 'react';
import { data, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

const Login = () => {
const [usuario, setUsuario] = useState("")
const [contraseña, setContraseña] = useState("")
const navigate = useNavigate();
const [error, setError] = useState(false)

const iniciarSesion = async (e) => {
  e.preventDefault();

  try {
    const respuesta = await fetch("https://disomex.onrender.com/api/login", {
      method: "POST",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        usuario,
        contraseña,
      }), // Datos a enviar
    });

    // Lee los datos de la respuesta una vez
    const data = await respuesta.json();

    if (respuesta.ok) {
      console.log("Inicio de sesión exitoso:", data);
      console.log(Cookies.get("authToken"))
      navigate("/servicios-admin"); // Redirección
      window.location.reload()
      
    } else {
      console.error("Error al iniciar sesión:", data.error || "Error desconocido");
      setError(true)

      setTimeout(() => {
        setError(false)
      }, 4000);
    }
  } catch (error) {
    console.error("Error al enviar el formulario:", error.message);
    // Manejo de errores de red
  }
};

return (
    
    <div>
      {error && (
      <div className="fixed top-20 left-0 right-0 flex justify-center items-center m-auto w-[70%] h-[10%] mt-4 p-2 rounded-xl bg-red-600 text-white text-center text-xl z-10">
          <p className="font-semibold">Usuario o contraseña incorrectos</p>
        </div>)}

      <div className='bg-slate-500 flex justify-center items-center p-6 h-[75vh] '>
        <form onSubmit={iniciarSesion} className='bg-[#1a354b] p-4 flex flex-col justify-center w-[90%] h-[400px] sm:w-[50%] sm:h-[500px]'>
            <h1 className='text-center text-white text-3xl mb-2'>Login</h1>
            <input type="text" placeholder='Usuario' required className='mb-8 p-2 w-full bg-[#335571] text-white rounded-md outline-none focus:ring-2 focus:ring-[#e9aa0d]' 
            onChange={ (e) => setUsuario(e.target.value)}/>
            <input type="password" placeholder='Contraseña' required className='mb-8 p-2 w-full bg-[#335571] text-white rounded-md outline-none focus:ring-2 focus:ring-[#e9aa0d]'
            onChange={ (e) => setContraseña(e.target.value)}/>
            <button
              type="submit"
              className="bg-[#e9aa0d] w-full text-white mb-8 py-2 rounded-md hover:bg-orange-600 transition-all duration-300"
            >
              Iniciar Sesion
            </button>
        </form>
        
      </div>
    </div>
  );
};

export default Login;